/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const segmentContentCss = ":host{scroll-snap-align:center;scroll-snap-stop:always;-ms-flex-negative:0;flex-shrink:0;width:100%;min-height:1px;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none;}:host::-webkit-scrollbar{display:none}";

const SegmentContent = /*@__PURE__*/ proxyCustomElement(class SegmentContent extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: 'db6876f2aee7afa1ea8bc147337670faa68fae1c' }, h("slot", { key: 'bc05714a973a5655668679033f5809a1da6db8cc' })));
    }
    static get style() { return segmentContentCss; }
}, [257, "ion-segment-content"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["ion-segment-content"];
    components.forEach(tagName => { switch (tagName) {
        case "ion-segment-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SegmentContent);
            }
            break;
    } });
}

const IonSegmentContent = SegmentContent;
const defineCustomElement = defineCustomElement$1;

export { IonSegmentContent, defineCustomElement };
